import React from 'react';
import LoveCodeHero from './LoveCodeHero';
import TheShift from './TheShift';
import DualityMap from './DualityMap';
import Foundation from './Foundation';
import JenniferAuthority from './JenniferAuthority';
import FuturePacing from './FuturePacing';
import LoveCodeDEFooter from './LoveCodeDEFooter';

const LoveCodeDE = () => (
  <main className="bg-dark min-h-screen overflow-x-hidden">
    <h1 className="sr-only">
      Love Code Seelenpartner – Affäre, intensive Verbindung, emotionale Abhängigkeit lösen, Beziehungsheilung
    </h1>
    <LoveCodeHero />
    <TheShift />
    <DualityMap />
    <Foundation />
    <JenniferAuthority />
    <FuturePacing />
    <LoveCodeDEFooter />
  </main>
);

export default LoveCodeDE;